import Cookies from 'js-cookie';

export default {
  init() {
    // JavaScript to be fired on the home page

    if($('#popup-manageable').length > 0) {

      if(Cookies.get('hp_popup_opened') != '1') {
        $('#popup-manageable').modal('show');
        Cookies.set('hp_popup_opened', '1', { expires: 365 });
      }

    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js